module.exports = __webpack_public_path__ + "static/media/full.dfb0aed6.svg";